<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>生产管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ flowStatusNames[flowStatus] }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div class="filters">
        <span>筛选</span>
        <div class="filter">
          <!-- <el-select v-model="filterUser" placeholder="筛选执行人">
                  <el-option
                    v-for="item in users"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>-->
          <el-input
            placeholder="输入钻头名称筛选"
            v-model="product"
            size="small"
            clearable
            style="margin-right: 10px"
          ></el-input>
          <el-button type="primary" size="small" @click="requestHistories"
            >搜索</el-button
          >
        </div>
      </div>
      <div class="flows" v-for="(flow, x) in flows" :key="flow.id">
        <div class="flow-head">
          <div class="flow-head-title">
            <h4>
              <span>{{ flow.product.name }}</span>
              （{{ flow.name }}）
            </h4>
            <div style="min-width: 100px; text-align: right">
              <span>{{ dateDisplay(flow.start_time) }}</span>
              <div v-if="flow.status == 4" class="ml-10">
                <el-button @click="restartFlow(x)" size="mini" type="warning">
                  <i class="btn-label ion-settings"></i>恢复
                </el-button>
              </div>
            </div>
          </div>
          <div class="flow-head-status"></div>
        </div>
        <div class="steps">
          <!-- <div class="line"></div> -->
          <div class="step tasklist" v-for="(group, y) in flow.taskGroups">
            <div class="circle" :class="{ current: y <= flow.current_step }">
              {{ y + 1 }}
            </div>
            <div
              @click="clickedTask(x, y, z)"
              class="task"
              v-for="(task, z) in group"
              :class="task.style.taskClass"
            >
              <span class="task-title">{{ task.name }}</span>
              <span class="task-user" v-if="task.user_id > 0">{{
                task.user_name
              }}</span>
              <span class="task-user" v-else>
                <i class="ion-person"></i>
              </span>
              <span
                v-if="task.inspect_logs.length > 0"
                class=""
                @click.stop="showInspectLogs(task)"
              >
                <i class="ion-information-circled text-warning"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      ></el-pagination>
      <div v-if="total == 0" class="panel-body">暂无数据。</div>
    </div>
    <check-task :task="selectTask"></check-task>
    <inspect-log-viewer :logs="selectInspectorLogs"></inspect-log-viewer>
  </div>
</template>

<script>
import {
  flowHistories,
  getTaskUsers,
  assignTask,
  pauseOrStartFlow,
} from '@/service/getData'
import Multiselect from 'vue-multiselect'
import { taskStyle } from '@/utils/index'
import checkTask from '@/views/produce/flow/check_task'
import inspectLogViewer from '@/components/InspectLogViewer'

export default {
  components: { Multiselect, checkTask, inspectLogViewer },
  data() {
    return {
      flowStatusNames: {
        2: '历史生产',
        3: '关闭生产',
        4: '暂停生产',
      },
      flowStatus: this.$route.meta.flowStatus,
      flows: [],
      total: 0,
      pageSize: 20,
      assignTaskId: null,
      assignTaskY: null,
      assignTaskX: null,
      assignTaskZ: null,
      selectTask: null,
      product: '',
      selectInspectorLogs: [],
    }
  },
  watch: {
    $route: function () {
      this.flows = []
      this.product = ''
      this.flowStatus = this.$route.meta.flowStatus
      this.initData()
    },
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.requestHistories()
    },
    async requestHistories(page) {
      if (!page) {
        page = 0
      }
      let data = {
        page: page,
        page_size: this.pageSize,
        status: this.flowStatus,
      }

      if (this.product.length > 0) {
        data.product = this.product
      }
      let res = await flowHistories(data)
      let list = res.data.list
      let that = this
      this.flows = list.map((item) => {
        return that.handlerFlow(item)
      })
      this.total = res.data.total
    },
    restartFlow(index) {
      let that = this
      this.$confirm('确认恢复生产流程？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let data = {
            id: that.flows[index].id,
          }
          pauseOrStartFlow(data).then((res) => {
            if (res.code == 0) {
              that.$message({
                showClose: false,
                duration: 1000,
                message: '生产流程已恢复',
                type: 'success',
              })
              that.flows.splice(index, 1)
            }
          })
        })

        .catch(() => {})
    },
    handlerFlow(item) {
      var taskGroups = []
      item.tasks.map((task) => {
        let index = task.step
        if (!taskGroups[index]) {
          taskGroups[index] = []
        }
        task.style = taskStyle(task.status)
        taskGroups[index].push(task)
      })

      item.taskGroups = taskGroups
      return item
    },
    clickedTask(x, y, z) {
      this.assignTaskX = x
      this.assignTaskY = y
      this.assignTaskZ = z

      let task =
        this.flows[this.assignTaskX].taskGroups[this.assignTaskY][
          this.assignTaskZ
        ]
      this.selectTask = task
      $('#TaskCheck').modal('show')
    },

    showInspectLogs(task) {
      this.selectInspectorLogs = task.inspect_logs
      $('#InspectLogViewer').modal('show')
    },
    handleCurrentChange(e) {
      this.requestHistories(e - 1)
    },

    dateDisplay(date) {
      return date.split('T')[0]
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.actions span {
  display: inline-block;
  margin-right: 1em;
  cursor: pointer;
}

.steps {
  display: flex;
  overflow-x: scroll;
  position: relative;
  flex-wrap: wrap;
}

.step {
  position: relative;
  min-width: 200px;
  max-width: 200px;
  margin-left: 16px;
  margin-right: 4px;
  margin-bottom: 12px;
  border-radius: 4px;
  padding: 5px;
}

.step .circle {
  position: absolute;
  left: -16px;
  top: 8px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  text-align: center;
  background-color: #fff;
  z-index: 2;
  font-size: 12px;
  font-family: 'Courier New', Courier, monospace;
}

.step .circle.current {
  background-color: #8bc34a;
  border-color: #8bc34a;
  color: #fff;
}

/* .step .circle::after {
  position: absolute;
  content: '';
  left: 50%;
  top: 18px;
  width: 1px;
  height: 20px;
  background-color: #eee;
} */

.task {
  padding: 0 10px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
  cursor: pointer;
}

.task .task-title {
  height: 24px;
  line-height: 24px;
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.task:hover {
  background-color: #f5f5f5;
}

.task:last-child {
  margin-bottom: 0;
}

.task-footer {
  margin-top: 10px;
  height: 33px;
}
.user-set {
  cursor: pointer;
}
.task-user {
  color: #294f75;
  width: 60px;
  text-align: right;
}
.ti-user {
  margin-right: 2px;
}

.tasklist .task-footer {
  text-align: left;
}

.flows {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dotted #ddd;
}

.guides {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 18px;
  margin-top: 5px;
}

.guide {
  height: 100%;
  margin-left: 12px;
  display: flex;
  cursor: pointer;
  padding: 2px 8px;
  border: 1px solid #fff;
  border-radius: 3px;
}

.filter-user {
  margin-top: 15px;
  display: flex;
  align-items: center;
}

.filter-user-selector {
  margin-left: 12px;
  width: 200px;
}

.guide.active {
  border-color: #ab47bc;
}

.statuses {
  display: flex;
}
.guide span {
  display: inline-block;
  width: 2px;
  height: 12px;
  margin-right: 3px;
  margin-top: 2px;
}
.bg-default {
  background-color: #aaa;
}
.flow-head {
  margin: 8px 0;
  line-height: 22px;
}
.flow-head-title {
  display: flex;
  justify-content: space-between;
}

.flow-head-title h4 {
  font-size: 12px;
  margin: 0;
}

.flow-head-title h4 span {
  font-size: 14px;
  font-weight: bold;
}
.field-show label {
  color: #333;
  font-size: 14px;
}
.field-show div {
  margin-bottom: 12px;
}

.filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filter {
  display: flex;
}
.filter div:only-child {
  margin-right: 5px;
}
</style>

<style>
.field-show img {
  width: 80px;
  height: auto;
  max-height: 80px;
  margin-right: 10px;
}
.ion-information-circled {
  margin-left: 2px;
}
</style>